import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  height: 100%;
  overflow: auto;
`;

export { Container };
